import {inlineError} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

/**
 * @implements UseCase
 */
export default class UpdateSubscriptionsUserUseCase extends UseCase {
  /**
   * @constructor
   * @param {Object} deps
   * @param {UseCase} deps.userRepository
   */
  constructor({userRepository, subscriptionsParamsRequestFactory, fromSubscriptionsParamRequestToApiBodyMapper}) {
    super({})
    this._userRepository = userRepository
    this._subscriptionsParamsRequestFactory = subscriptionsParamsRequestFactory
    this._fromSubscriptionsParamRequestToApiBodyMapper = fromSubscriptionsParamRequestToApiBodyMapper
  }

  @inlineError
  async execute({newSubscriptions, userId, token}) {
    const subscriptions = this._fromSubscriptionsParamRequestToApiBodyMapper.map(newSubscriptions)
    const subscriptionsParams = this._subscriptionsParamsRequestFactory({
      newSubscriptions: subscriptions,
      userId,
      token
    })
    const [error, userSubscriptions] = await this._userRepository.updateSubscriptions({subscriptionsParams})
    if (error) {
      throw error
    }

    return userSubscriptions.toJSON()
  }
}
